var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.9291C16.3923 15.4439 19 12.5265 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.5265 7.60771 15.4439 11 15.9291V18.4L8.06812 19.5728C7.42301 19.8308 7 20.4556 7 21.1504C7 21.6196 7.38038 22 7.84959 22H16.1504C16.6196 22 17 21.6196 17 21.1504C17 20.4556 16.577 19.8308 15.9319 19.5728L13 18.4V15.9291ZM9.76683 6.30489C9.43688 4.87848 10.52 3.5 12 3.5C13.48 3.5 14.5631 4.87849 14.2332 6.3049C13.6272 5.80221 12.8489 5.5 12 5.5C11.1511 5.5 10.3728 5.80221 9.76683 6.30489ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9ZM15.5 9C15.5 8.71962 15.467 8.44694 15.4048 8.18563L15.5988 8.2367C17.0599 8.62124 17.7554 10.2899 17 11.5983C16.2691 12.8643 14.567 13.1226 13.494 12.166C14.6797 11.6055 15.5 10.3986 15.5 9ZM10.5059 12.166C9.4328 13.1223 7.73091 12.864 7.00004 11.5981C6.2446 10.2896 6.94012 8.621 8.40124 8.23645L8.5953 8.18538C8.53299 8.44677 8.5 8.71953 8.5 9C8.5 10.3985 9.32024 11.6054 10.5059 12.166Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFan);
export default __webpack_public_path__ + "static/media/table-fan.0a3df26f6a27717a249c2a7c72d0e286.svg";
export { ForwardRef as ReactComponent };